import { Box, Typography } from "@mui/material";
import React from "react";
import { decodeHtml } from "../../utils";
import { useSelector } from "react-redux";

const Specification = ({ productDetail }) => {
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  return (
    <Box paddingY={5}>
      <div
        dangerouslySetInnerHTML={{
          __html: decodeHtml(productDetail.specification[currentLanguage]),
        }}
      ></div>
    </Box>
  );
};

export default Specification;
